module.exports = __webpack_public_path__ + "a0957dc790208a38c65077acebd7dda9.png";